import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

window.addEventListener("load", function () {
  const element = document.querySelector(".botton-nav");

  const showAnim = gsap
    .from(element, {
      yPercent: -100,
      opacity: 0,
      paused: true,
      duration: 0.5,
    })
    .progress(1);

  ScrollTrigger.create({
    start: "5% 15%",
    end: 99999,
    onUpdate: (self) => {
      self.direction === -1 ? showAnim.play() : showAnim.reverse();
    },
  });

  const mobileMenu = document.querySelector("#mobile-menu");

  document.querySelector("#hamburger-menu").addEventListener("click", () => {
    mobileMenu.classList.toggle("hidden");
  });
});
